import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.UserAssignmentContent>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'user_assignment_file',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(
      state,
      action: PayloadAction<Model.UserAssignmentContent[]>,
    ) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.UserAssignmentContent>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.UserAssignmentContent>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    increaseNumberOfComments(
      state,
      action: PayloadAction<Model.HomeworkComment>,
    ) {
      const currentUserFile =
        state.entities[action.payload.user_assignment_file_id];

      if (currentUserFile) {
        currentUserFile.total_comments++;
      }
    },
    decreaseNumberOfComments(
      state,
      action: PayloadAction<Model.HomeworkComment>,
    ) {
      const currentUserFile =
        state.entities[action.payload.user_assignment_file_id];

      if (currentUserFile) {
        currentUserFile.total_comments--;
      }
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.user_assignment_file,
);

export { reducer };
export default actions;
